import React from "react";
import { Outlet, Navigate } from "react-router-dom";

function PublicRoute(props) {
  const { restricted, user } = props || {};

  return user && !restricted ? (
    <Outlet />
  ) : (!user || user.isAnonymous) ? (
    <Outlet />
  ) : (
    <Outlet />
  );
}

export default PublicRoute;